import { EncumbrancesExcelRawRow } from '../types/EncumbrancesExcel';

const formatKeyForReplaceAccents = (key: string): string => {
  if (!key) return '';
  return key
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.toUpperCase();
};

export const mapExcelKeysToUppercase = (
  objectsList: EncumbrancesExcelRawRow[]
): EncumbrancesExcelRawRow[] => {
  if (!objectsList?.length) return [];

  return objectsList.map((object) => {
    const newObject: EncumbrancesExcelRawRow = {};
    Object.keys(object).forEach((key) => {
      const formattedKey = formatKeyForReplaceAccents(key);
      newObject[formattedKey] = object[key];
    });
    return newObject;
  });
};
